<template>
  <div id="js-enneagram-view">
    <v-container v-if="!assessment || !assessment.primary">
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-description">
          The main intention behind taking a personality typing assessment is to
          better understand ourselves. There are many different types of
          assessments out there; we have found the Enneagram particularly
          insightful. The Enneagram is a helpful tool that provides individuals
          with a look into their core motivations, while revealing key
          information about their communication styles and how they approach the
          world.
        </span>
      </v-row>
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-mentor-message">
          Your Mentor will work with you on when to take this assessment!
        </span>
      </v-row>
    </v-container>

    <enneagram-display
      :data="assessment"
      :userId="parseInt(userId)"
      :isMember="true"
    ></enneagram-display>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import User from "@/lib/user"
import { mapGetters } from "vuex"
import EnneagramDisplay from "@/components/assessments/EnneagramDisplay"

export default {
  mixins: [titleMixin],
  components: { EnneagramDisplay },
  data: function() {
    return {
      title: "Personality Style",
      userId: User.getUserId()
    }
  },
  created() {
    this.assessment = this.getAssessmentByType("Enneagram")
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/assessment-text";
</style>
